export enum DeliveryDeviceConditions {

    default = 1,
    broken = 2
} 